import { SetAppRoute } from '~/features/routes'
import { useLink } from '@features/use-link'
import { SideNavLink } from '@st/theme'
import { Fragment, ReactNode } from 'react'
import { FEATURE_FLAGS } from '~/env'
import { STAppHeaderNav } from './st-app-header-nav'
import { useOrganizationRole } from './use-organization-role'
import { OrganizationRole } from '@st/sdk'

export function OrganizationSettingsScaffold({
  title,
  children
}: {
  title: string
  children?: ReactNode
}) {
  const role = useOrganizationRole()
  return (
    <div style={{ minWidth: '1200px' }} className="flex flex-col">
      <STAppHeaderNav />

      <div className="px-16 py-8">
        <h1 className="mb-8 text-2xl">{title}</h1>
        <div className="grid grid-cols-[200px_auto] gap-4">
          <SettingsSubnav role={role} />
          <div>{children}</div>
        </div>
      </div>
    </div>
  )
}

function SettingsSubnav({ role }: { role: OrganizationRole }) {
  return (
    <div className="flex flex-col">
      <AppSideNavLink href={{ name: 'team' }}>Team</AppSideNavLink>
      {role != 'restricted' && (
        <Fragment>
          <AppSideNavLink href={{ name: 'branding' }}>Branding</AppSideNavLink>
          <AppSideNavLink href={{ name: 'manage_organization_tags' }}>Tags</AppSideNavLink>
          <AppSideNavLink href={{ name: 'manage_organization_message_templates' }}>
            Templates
          </AppSideNavLink>
          <AppSideNavLink href={{ name: 'client_organizer_settings' }}>
            Client Organizers
          </AppSideNavLink>
            <AppSideNavLink href={{ name: 'manage_organization_integrations' }}>
              Integrations
            </AppSideNavLink>
          {FEATURE_FLAGS.pushTaxReturn && (
            <AppSideNavLink href={{ name: 'desktop_agent_settings' }}>Desktop agent</AppSideNavLink>
          )}
          <AppSideNavLink href={{ name: 'organization_balance' }}>Balance</AppSideNavLink>
        </Fragment>
      )}
      <AppSideNavLink href={{ name: 'account' }}>Account</AppSideNavLink>
    </div>
  )
}

function AppSideNavLink(props: {
  href: SetAppRoute | string
  children: ReactNode
  onClick?: () => void
}) {
  const { href, onClick, isActive } = useLink({ href: props.href })

  return (
    <SideNavLink href={href} onClick={onClick} active={isActive}>
      {props.children}
    </SideNavLink>
  )
}
